import { ResourceProps } from "@refinedev/core";
import {
  IconAbc,
  IconBox,
  IconCertificate,
  IconMilitaryRank,
  IconSchool,
  IconSmartHome,
  IconUser,
  IconUserCog,
  IconUserEdit,
  IconUsers,
} from "@tabler/icons-react";
import React from "react";

export const ResourceIdentifier = {
  Association: "Association",
  AssociationRole: "AssociationRole",
  AssociationUser: "AssociationUser",
  AssociationGolfClass: "AssociationGolfClass",
  Certificate: "Certificate",
  CoachClass: "CoachClass",
  GolfClass: "GolfClass",
  User: "User",
  Membership: "Membership",
  ChangeRequest: "ChangeRequest",
};

export const apiResources: ResourceProps[] = [
  {
    identifier: ResourceIdentifier.Association,
    name: "association",
    meta: {
      label: "Home",
      icon: <IconSmartHome />,
    },
  },
  {
    identifier: ResourceIdentifier.AssociationUser,
    name: "association/:associationId/user",
    list: "/",
    meta: {
      label: "Profile",
      canDelete: true,
      icon: <IconUser />,
    },
  },
  {
    identifier: ResourceIdentifier.AssociationUser,
    name: "association/:associationId/user",
    meta: {
      label: "Edit profile",
      canDelete: true,
      icon: <IconUserEdit />,
    },
  },
  {
    identifier: "profile-settings",
    name: "association/:associationId/user",
    list: "/profile-settings",
    meta: {
      label: "Edit profile",
      canDelete: true,
      icon: <IconUserEdit />,
    },
  },

  {
    identifier: ResourceIdentifier.Certificate,
    name: "certificate",
    meta: {
      parent: "Other",
      label: "Certificates",
      icon: <IconCertificate />,
      // hide: true,
    },
  },
  {
    identifier: ResourceIdentifier.CoachClass,
    name: "coach-class",
    meta: {
      parent: "Other",
      icon: <IconSchool />,
      label: "Coach classes",
    },
  },
  {
    identifier: ResourceIdentifier.GolfClass,
    name: "golf-professional-level",
    meta: {
      parent: "Other",
      icon: <IconMilitaryRank />,
      label: "Golf classes",
    },
  },
  {
    identifier: ResourceIdentifier.AssociationGolfClass,
    name: "association/:associationId/golf-class",
    meta: {
      parent: ResourceIdentifier.Association,
      label: "Association golf class",
    },
  },
  {
    identifier: ResourceIdentifier.User,
    name: "users",
  },
  {
    identifier: ResourceIdentifier.Membership,
    name: "association/:associationId/membership",
  },
  {
    identifier: ResourceIdentifier.ChangeRequest,
    name: "association/:associationId/change-request",
  },
];
